"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Typography_1 = require("../Typography");
var styles_1 = require("./styles");
var DateItem = function (_a) {
    var date = _a.date, disabled = _a.disabled, current = _a.current, onClick = _a.onClick, onKeyDown = _a.onKeyDown, active = _a.active, pressed = _a.pressed, forwardedRef = _a.forwardedRef, dataTestId = _a["data-testid"];
    var containerClasses = (0, styles_1.useDateItemClasses)({
        current: current,
        disabled: disabled,
        active: active,
        pressed: pressed,
    });
    var labelClasses = (0, styles_1.useDateItemLabelClasses)({ disabled: disabled, current: current, active: active });
    return ((0, jsx_runtime_1.jsx)("div", __assign({ role: "button", ref: forwardedRef, onClick: disabled ? undefined : onClick, onKeyDown: onKeyDown, tabIndex: disabled ? -1 : 0, className: containerClasses, "data-testid": "".concat(dataTestId).concat(date.getDate()) }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: !disabled, className: labelClasses }, { children: date.getDate() })) })));
};
exports.DateItem = DateItem;
